import { PaymentMethodFormContext } from '../../../context/Form';

export default PaymentMethodFormContext;
